import { useCallback, useLayoutEffect, useState } from 'react';
import { heightBreakpoints, widthBreakpoints } from 'styles/general/variables';
import { BreakpointsType, HeightBreakpointsType } from 'types';

const useClientSize = () => {
  const [width, setWidth] = useState<number>();
  const [height, setHeight] = useState<number>();

  const getIsBreakpoint = (breakpoint: BreakpointsType) => {
    if (!width) return false;

    const breakpointWidth = widthBreakpoints[breakpoint];

    return breakpointWidth >= width;
  };

  const getIsHeightBreakpoint = (breakpoint: HeightBreakpointsType) => {
    if (!height) return false;

    const breakpointHeight = heightBreakpoints[breakpoint];

    return breakpointHeight >= height;
  };

  const getBreakpoint = useCallback(
    (screenWidth?: number): BreakpointsType | null => {
      const targetWidth = screenWidth || width || 0;

      const enums = Object.keys(widthBreakpoints) as BreakpointsType[];

      const targetEnum = enums.find((enumItem) => targetWidth >= widthBreakpoints[enumItem]);

      if (!targetEnum || !targetWidth) return null;

      return targetEnum;
    },
    [height, width],
  );

  useLayoutEffect(() => {
    const handleResize = () => {
      setWidth(document.documentElement.clientWidth || undefined);
      setHeight(document.documentElement.clientHeight || undefined);
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { width, height, getIsBreakpoint, getBreakpoint, getIsHeightBreakpoint };
};

export default useClientSize;
